import { render } from "./BtnConfigs.vue?vue&type=template&id=0990f379&scoped=true"
import script from "./BtnConfigs.vue?vue&type=script&lang=js"
export * from "./BtnConfigs.vue?vue&type=script&lang=js"

import "./BtnConfigs.vue?vue&type=style&index=0&id=0990f379&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0990f379"]])

export default __exports__